import { Header } from 'shared/ui/header';

import { CaregiverFormProvider } from '../model';

import { CaregiverFormContainer } from './CaregiverFormContainer';

export const CaregiverFormPage = () => {
  return (
    <CaregiverFormProvider>
      <Header />
      <CaregiverFormContainer />
    </CaregiverFormProvider>
  );
};

export default CaregiverFormPage;
